import styled from 'styled-components/macro';
import { variables } from 'theme/variables';

const {
  custom_blue: customBlue,
  color_blue_700: colorBlue700,
  color_white: colorWhite,
} = variables;

// LINT OVERRIDE #4
// More exports will be added (this override can be removed at that time)
// eslint-disable-next-line import/prefer-default-export
export const ElementBlockWrapper = styled('div')`
  background-color: ${(props) =>
    props.elementNumber < 17 ? customBlue : colorBlue700};
  color: ${colorWhite};
  min-width: 85px;
  height: 85px;
  width: 85px;
  max-width: 85px;
  margin-left: 3px;
  padding: 10px 15px 3px;
  border-radius: 0.2em;
  .symbol {
    font-size: 1.5em;
  }
  .at_num {
    font-size: 1em;
    align-self: flex-start;
  }
  .elem_name {
    padding-top: 0.2em;
    font-size: 0.8em;
  }
  .range {
    padding-top: 0.7em;
    font-size: 0.7em;
  }
  @media (max-width: 768px) {
    .symbol {
      font-size: 1.3em;
    }
    .elem_name {
      font-size: 0.5em;
    }
    .range {
      font-size: 0.45em;
    }
  }
  @media (max-width: 425px) {
    height: 80px;
    padding-left: 12px;
    .symbol {
      font-size: 1em;
    }
    .elem_name {
      font-size: 0.45em;
    }
    .range {
      font-size: 0.48em;
    }
  }
`;
